import { get, isPlainObject, omit } from "lodash-es";
/** 从object上拿到所有的path */
export function* walkObjectStrings(value, place = []) {
  if (Array.isArray(value)) {
    for (let i = 0; i < value.length; i++) yield* walkObjectStrings(value[i], [...place, i]);
  }
  if (isPlainObject(value)) {
    for (const key in value) {
      if (Object.prototype.hasOwnProperty.call(value, key)) {
        yield* walkObjectStrings(value[key], [...place, key]);
      }
    }
  }
  if (!(value instanceof Object)) {
    yield {
      value,
      place
    };
  }
}
/**  输入搜索的关键词 和一个对象, 从对象上找出符合的搜索结果 as Generator<WalkObject>  */
export function* searchKeyInObjectDeep(key, object, cmp, translateObj = {
  translatePath: {},
  translateValue: {}
}, pathBlackList = []) {
  const {
    translatePath,
    translateValue
  } = translateObj;
  // 剔除结构中子树的部分
  const obj = omit(object, pathBlackList);
  const pathMap = new Map();
  for (const walk of walkObjectStrings(obj)) {
    const pathMapTemp = new Map();
    const keywords = String(walk.value).trim();
    if (cmp(keywords, key)) {
      // 从value中查找
      const pathStr = JSON.stringify(walk.place);
      pathMapTemp.set(pathStr, walk);
    } else if (translatePath && cmp(translatePath[keywords], key)) {
      // 带路径翻译从value匹配
      pathMapTemp.set(JSON.stringify(walk.place), walk);
    } else if (translateValue && cmp(translateValue[keywords], key)) {
      // 只适用于value的翻译
      pathMapTemp.set(JSON.stringify(walk.place), walk);
    }
    // 从path中查找
    let placeIndex = walk.place.findIndex(str => cmp(str, key));
    // 翻译转换key转中文 再被查找
    let translateKey = '';
    if (placeIndex === -1 && translatePath) {
      placeIndex = walk.place.map(str => translatePath[str]).findIndex(str => cmp(str, key));
      if (placeIndex !== -1) translateKey = translatePath[walk.place[placeIndex]];
    }
    if (placeIndex !== -1) {
      // 路径上有 找到对应路径 然后按照key被发现的节点 返回path和object
      const parentPath = walk.place.slice(0, placeIndex + 1);
      const searchHitObject = get(obj, parentPath);
      const pathStr = JSON.stringify(parentPath);
      if (!pathMapTemp.has(pathStr)) {
        pathMapTemp.set(pathStr, {
          value: JSON.stringify(searchHitObject),
          place: parentPath,
          translateKey
        });
      }
    }
    for (const pathStr of pathMapTemp.keys()) {
      if (pathMap.has(pathStr)) continue;
      const value = pathMapTemp.get(pathStr);
      pathMap.set(pathStr, value);
      const translateWalkObject = pathObjIn => {
        const pathObj = {
          ...pathObjIn
        };
        const translatePathOutPut = pathObj.place.map(pathPart => {
          const temp = String(pathPart);
          if (!translatePath) return temp;
          if (temp in translatePath) {
            return translatePath[temp];
          }
          return temp;
        });
        if (translatePath) {
          if (pathObj.value in translatePath) {
            pathObj.value = translatePath[pathObj.value];
          }
        }
        if (translateValue) {
          if (pathObj.value in translateValue) {
            pathObj.value = translateValue[pathObj.value];
          }
        }
        return {
          ...pathObj,
          translatePath: translatePathOutPut
        };
      };
      const translateRes = translateWalkObject(value);
      // 执行translatePlugin
      if (Array.isArray(translateObj.translatePlugins)) {
        translateObj.translatePlugins.forEach(plugin => {
          try {
            plugin.translate(translateRes, obj);
          } catch (e) {
            console.error('translatePlugin error', e);
          }
        });
      }
      yield translateRes;
    }
  }
  return undefined;
}
/**  从一行str上搜出结果来  */
export function* searchStringInStringArray(key, stringArray, cmp) {
  for (let lineIndex = 0; lineIndex < stringArray.length; lineIndex += 1) {
    const line = stringArray[lineIndex];
    if (cmp(line, key)) {
      // 从value中查找
      const pathStr = `${lineIndex + 1}行`;
      const res = {
        value: line,
        place: [pathStr]
      };
      yield res;
    }
  }
  return undefined;
}
//# sourceMappingURL=util.js.map
